export const REPLY_POLICY = {
  FACEBOOK:
    'https://developers.facebook.com/docs/messenger-platform/policy/policy-overview/',
  TWILIO_WHATSAPP:
    'https://www.twilio.com/docs/whatsapp/tutorial/send-whatsapp-notification-messages-templates#sending-non-template-messages-within-a-24-hour-session',
  WHATSAPP_CLOUD:
    'https://business.whatsapp.com/policy#:~:text=You%20may%20reply%20to%20a,messages%20via%20approved%20Message%20Templates.',
  TIKTOK: 'https://business-api.tiktok.com/portal/docs?id=1832184236919810',
};

export const CHANGELOG_API_URL = 'https://hub.2.harkenlabs.com/changelogs';
